import React from 'react';

import DatePickerMobile from './DatePickerMobile.jsx';
import DatePickerDesktop from './DatePickerDesktop.jsx';
import helpers from '../../lib/helpers';

export default function FieldDate(props) {
  return (helpers.isMobile()) ? <DatePickerMobile field="date" name={props.name} /> : <DatePickerDesktop field="date" name={props.name} />;
}
